export const LB = 0.453592;

export const toKg = (h) => {
  const q = parseFloat(h.quantity) || 0;
  const u = (h.unit || 'kg').toLowerCase();
  return u.startsWith('lb') ? q * LB : u === 'oz' ? q * 0.0283495 : u === 'g' ? q / 1000 : q;
};

export const displayUnit = (defaultUnit) => (!defaultUnit || defaultUnit === 'kg' ? 'kg' : 'lbs');
export const kgTo = (kg, unit) => (unit === 'lbs' ? kg / LB : kg);
export const toUnit = (h, unit) => kgTo(toKg(h), unit);

export const harvestHiveIds = (h) => [...new Set([...(h.hive_ids || []), h.hive_id].filter(Boolean))];

export const harvestYard = (h, hives = []) => {
  if (h.yard) return h.yard;
  const id = harvestHiveIds(h)[0];
  return hives.find(x => x.id === id)?.yard || 'Unassigned';
};

export const harvestRevenue = (h) => (parseFloat(h.quantity) || 0) * (parseFloat(h.sale_price) || 0);

export const buildApiaryYield = (harvests, hives = [], unit = 'kg') => {
  const groups = {};
  harvests.forEach(h => {
    const yard = harvestYard(h, hives);
    const g = (groups[yard] = groups[yard] || { apiary: yard, total: 0, harvests: 0, frames: 0, revenue: 0, hiveKeys: new Set() });
    g.total += toUnit(h, unit);
    g.harvests += 1;
    g.frames += parseInt(h.frames_harvested) || 0;
    g.revenue += harvestRevenue(h);
    const ids = harvestHiveIds(h);
    (ids.length ? ids : (h.hive_numbers || [h.hive_number]).filter(Boolean).map(n => `#${n}`)).forEach(k => g.hiveKeys.add(k));
  });
  return Object.values(groups).map(({ hiveKeys, ...g }) => ({
    ...g,
    total: Math.round(g.total * 10) / 10,
    hives: hiveKeys.size,
    perHive: Math.round((g.total / Math.max(1, hiveKeys.size)) * 10) / 10
  })).sort((a, b) => b.perHive - a.perHive);
};
